import { sortBy } from 'lodash';

import type { BetType, RunnerId } from '@swf/generated/types/api/sports';

/**
 * Mimics the opportunityId creation from the BFF layer.
 */
export const buildOpportunityId = (betType: BetType, runnerIds: RunnerId[]): string => {
  const ids = sortBy(runnerIds, ['marketId', 'selectionId'])
    .map(({ marketId, selectionId }) => `${marketId}_${selectionId}`)
    .join('_')
    .replace(/\./g, '_');

  return `${betType}_${ids}`;
};
